import cx from "classnames";

const COMMON_CLASS =
  "w-2 h-2 bg-neutral dark:bg-neautral-lightest rounded-full animate-bounce";

const TypingIndicator = () => (
  <div className="flex justify-start">
    <div className="px-4 py-3 rounded-2xl rounded-bl-md bg-neutral-lightest dark:bg-neutral-dark">
      <div className="flex gap-1">
        <div className={cx(COMMON_CLASS, "[animation-delay:-0.3s]")} />
        <div className={cx(COMMON_CLASS, "[animation-delay:-0.15s]")} />
        <div className={COMMON_CLASS} />
      </div>
    </div>
  </div>
);

export default TypingIndicator;
